import { FormState } from 'src/types';
import { HeaderRow } from '.';
import { StyledTextArea } from '../ReviewCaseTeamMemberModal.styles';

interface NoteProps {
  caseTeamNoteText?: string;
  title: string;
  'data-testid'?: string;
}

export const Note = ({ caseTeamNoteText, title, ...props }: NoteProps) => {
  return (
    <>
      <HeaderRow icon="link" title={title} />
      <StyledTextArea
        state={FormState.READONLY}
        value={caseTeamNoteText}
        disabled
        {...props}
      />
    </>
  );
};
